
import { CustomerEffects } from './customer.effects';
import { PolicyEffects } from './policy.effects';
import { CertificateEffects } from './certificate.effects';
import { QueryEffects } from './query.effects';
import { CertificateTypeEffects } from './certificate-type.effects';
import { RoleEffects } from './role.effects';
import { AreaEffects } from './area.effects';
import { CertificateHistoricalEffects } from './certificate-historical.effects';
import { GeneralConfigEffects } from './general-config.effects';

export const configurationsEffects = [
    CustomerEffects,
    PolicyEffects,
    CertificateEffects,
    CertificateHistoricalEffects,
    QueryEffects,
    CertificateTypeEffects,
    RoleEffects,
    AreaEffects,
    GeneralConfigEffects,
]
